export default __webpack_public_path__ + "static/media/icon-analytics.2b958fc0.svg";